import React from "react";
import ContentLoader from "react-content-loader";


const TournamentLoader = () => (
    <ContentLoader
        height={60}
        width={'100%'}
        speed={1}
        backgroundColor={'#cfd8dc'}
        foregroundColor={'#eceff1'}
    >
        {/* Only SVG shapes */}
        <circle cx="12" cy="14" r="11" />
        <rect x="32" y="8" rx="8" ry="8" width="150" height="14" />
        <rect x="4" y="42" rx="5" ry="5" width="70" height="12" />
        <rect x="82" y="42" rx="5" ry="5" width="70" height="12" />
        {/* <rect x="160" y="42" rx="5" ry="5" width="70" height="12" /> */}
    </ContentLoader>
)

export default TournamentLoader